import Gallery from 'react-masonry-css'
import React from 'react'

const Masonry = ({ items, isAreaPersonale = false }) => {
  const breakpoints = isAreaPersonale
    ? {
        default: 3,
        1100: 2,
        560: 1,
      }
    : {
        default: 4,
        1150: 3,
        780: 2,
        560: 1,
      }

  return (
    <Gallery breakpointCols={breakpoints} className="masonry" columnClassName="masonry__item">
      {items}
    </Gallery>
  )
}

export default Masonry
